import { render, staticRenderFns } from "./CustomSelectionEditColumn.vue?vue&type=template&id=83bdd314&scoped=true&"
import script from "./CustomSelectionEditColumn.vue?vue&type=script&lang=js&"
export * from "./CustomSelectionEditColumn.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectionEditColumn.vue?vue&type=style&index=0&id=83bdd314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bdd314",
  null
  
)

export default component.exports